import { useMemo } from "react";
import { checkboxesOrder } from "../setupAssistantUtils";
import { FEModules, FEModulesObj } from "@utils/moduleList";
import type { TranslationKey } from "@typedefs/modulesInterfaces";
import { FieldType } from "@typedefs/modulesInterfaces";

interface SpecialCheckboxesInputGroup {
	inputName: string;
	label: TranslationKey;
	options: { name: TranslationKey; id: string | number }[];
	type: FieldType.CHECKBOXES;
	disabled?: boolean;
}

export const useModulesInput = (): SpecialCheckboxesInputGroup => {
	return useMemo(() => {
		const orderMap = new Map();
		checkboxesOrder.forEach((id, index) => orderMap.set(id, index));

		const options = Object.keys(FEModulesObj)
			.map((key) => ({
				name: FEModulesObj[Number(key) as FEModules].name,
				id: key,
			}))
			.filter((opt) => opt.id !== `${FEModules.ActivityComplete}`)
			.sort((a, b) => orderMap.get(+a.id) - orderMap.get(+b.id));

		return {
			inputName: "modulesList",
			label: "" as TranslationKey,
			options: options,
			type: FieldType.CHECKBOXES,
		};
	}, []);
}; 